import type { PLAAttributeDefinition } from "./PLAState";

type PLAElementTransformAttributeDefinition = Pick<PLAAttributeDefinition, "type" | "valueType" | "cubeDimensions">;

export function getPLAElementTransformValueError(value: unknown, definition: PLAElementTransformAttributeDefinition): string | undefined {
   if (definition.type === "cube") {
      if (!value || typeof value !== "object" || Array.isArray(value)) return "Transform result must be a cube";
      const cube = value as { cells?: unknown; dimensions?: unknown; valueType?: unknown };
      if (!cube.cells || typeof cube.cells !== "object" || Array.isArray(cube.cells) || !cube.dimensions || !Array.isArray(cube.dimensions)) return "Transform result must be a cube";
      if (!["number", "m2", "stk", "kr"].includes(definition.valueType || "")) return "Cube destination attribute must have a numeric value type";
      if (cube.dimensions.some((dimension) => typeof dimension !== "string")) return "Transform cube dimensions do not match the selected attribute";
      const expectedDimensions = (definition.cubeDimensions || []).map((dimension) => dimension.elementTypeId);
      if (JSON.stringify(cube.dimensions) !== JSON.stringify(expectedDimensions)) return "Transform cube dimensions do not match the selected attribute";
      if (cube.valueType !== undefined && cube.valueType !== definition.valueType) return "Transform cube value type does not match the selected attribute";
      for (const [key, cellValue] of Object.entries(cube.cells)) {
         if (key.split("\u001f").length !== expectedDimensions.length || typeof cellValue !== "number" || !Number.isFinite(cellValue)) {
            return "Transform cube cells must contain finite numbers with matching dimensions";
         }
      }
      return undefined;
   }
   if (definition.type !== "constant" || !definition.valueType) return "Transform result cannot be written to this attribute";
   const valueType = definition.valueType;
   if (["number", "m2", "stk", "kr"].includes(valueType)) {
      return typeof value === "number" && Number.isFinite(value) ? undefined : "Transform result must be a finite number";
   }
   if (valueType === "boolean") return typeof value === "boolean" ? undefined : "Transform result must be a boolean";
   if (valueType === "date") return typeof value === "string" && Number.isFinite(Date.parse(value)) ? undefined : "Transform result must be a valid date";
   return typeof value === "string" ? undefined : "Transform result must be text";
}

export function getPLAElementTransformStoredValue(value: unknown, definition: PLAElementTransformAttributeDefinition): unknown {
   if (definition.type !== "cube" || !value || typeof value !== "object" || Array.isArray(value)) return value;
   return { cells: (value as { cells: Record<string, unknown> }).cells };
}

export function arePLAElementTransformValuesEqual(left: unknown, right: unknown): boolean {
   if (Object.is(left, right)) return true;
   if (!left || !right || typeof left !== "object" || typeof right !== "object") return false;
   return JSON.stringify(left) === JSON.stringify(right);
}
